import { useState } from "react";
import { LuChevronsUpDown } from "react-icons/lu";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from "../dropdown/DropDownV2";
import { ProductionTypeProjectFilters } from "config";

export const ProductionTypeDropdown = ({ onChange }: { onChange: (value: string) => void }) => {
  const [selectedProduction, setSelectedProduction] = useState<string>("");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex flex-row gap-[1em] px-6 items-center card card-border h-fit cursor-pointer">
          <div className="flex flex-row gap-2 justify-start z-40">
            <div className="opacity-50">Type:</div>
            <div className="capitalize">{selectedProduction || "Select Type"}</div>
          </div>
          <LuChevronsUpDown />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuGroup className="flex flex-col max-h-64 overflow-y-auto gap-1">
          {Object.keys(ProductionTypeProjectFilters).map((prod_type) => (
            <DropdownMenuItem
              key={prod_type}
              onClick={() => {
                setSelectedProduction(prod_type);
                onChange(ProductionTypeProjectFilters[prod_type]);
              }}
            >
              <span className={selectedProduction == prod_type ? "text-primary" : ""}>
                {prod_type}
              </span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
